__turbopack_context__.v({
  "container": "frequencychannelfinder-module-scss-module__EQRRPa__container",
  "formInfoText": "frequencychannelfinder-module-scss-module__EQRRPa__formInfoText",
  "frequencyFinderWrapper": "frequencychannelfinder-module-scss-module__EQRRPa__frequencyFinderWrapper",
  "hasFrequencyBox": "frequencychannelfinder-module-scss-module__EQRRPa__hasFrequencyBox",
  "links": "frequencychannelfinder-module-scss-module__EQRRPa__links",
  "list": "frequencychannelfinder-module-scss-module__EQRRPa__list",
});
